import React from 'react';
import Modal from './Modal';
import { format } from 'date-fns';
import Icon from './Icon';

const ModalDetails = ({ isOpen, onClose, apprenant }) => {
  if (!apprenant) return null;

  const formatDate = (date) => {
    if (!date) return '-';
    try {
      return format(new Date(date), 'dd/MM/yyyy');
    } catch {
      return date;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <span className="flex items-center">
          <Icon name="view" size={20} className="mr-2" />
          Détails
        </span>
      }
      size="lg"
    >
      <div className="space-y-6">
        {/* Informations Personnelles */}
        <div className="border-l-4 border-red-600 pl-4 bg-red-50 rounded-r-lg py-4 pr-4">
          <h3 className="font-bold text-red-800 mb-3 flex items-center">
            <Icon name="user" size={18} className="mr-2" />
            Informations Personnelles
          </h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="font-medium text-gray-600">Nom :</span>
              <p className="font-semibold">{apprenant.nom}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Prénoms :</span>
              <p className="font-semibold">{apprenant.prenom || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Genre :</span>
              <p className="font-semibold">{apprenant.genre || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Âge :</span>
              <p className="font-semibold">{apprenant.age || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Téléphone :</span>
              <p className="font-semibold">{apprenant.telephone || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Email :</span>
              <p className="font-semibold">{apprenant.email || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Ville :</span>
              <p className="font-semibold">{apprenant.ville || '-'}</p>
            </div>
          </div>
        </div>

        {/* Profil Entrée */}
        <div className="border-l-4 border-purple-600 pl-4 bg-purple-50 rounded-r-lg py-4 pr-4">
          <h3 className="font-bold text-purple-800 mb-3 flex items-center">
            <Icon name="document" size={18} className="mr-2" />
            Profil Entrée
          </h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="font-medium text-gray-600">Diplôme :</span>
              <p className="font-semibold">{apprenant.diplome || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Statut entrée :</span>
              <p className="font-semibold">{apprenant.statutEntree || '-'}</p>
            </div>
          </div>
        </div>

        {/* Formation */}
        <div className="border-l-4 border-blue-600 pl-4 bg-blue-50 rounded-r-lg py-4 pr-4">
          <h3 className="font-bold text-blue-800 mb-3 flex items-center">
            <Icon name="book" size={18} className="mr-2" />
            Formation
          </h3>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="font-medium text-gray-600">Type :</span>
              <p className="font-semibold">{apprenant.typeFormation || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Filière :</span>
              <p className="font-semibold">{apprenant.filiere || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Formateur :</span>
              <p className="font-semibold">{apprenant.formateur || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Date début :</span>
              <p className="font-semibold">{formatDate(apprenant.dateDebut)}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Date fin :</span>
              <p className="font-semibold">{formatDate(apprenant.dateFin)}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Année de formation :</span>
              <p className="font-semibold">{apprenant.anneeFormation || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Durée de formation :</span>
              <p className="font-semibold">{apprenant.dureeFormation || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Promotion :</span>
              <p className="font-semibold">{apprenant.promotion || '-'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Abandon :</span>
              <p className="font-semibold">{apprenant.abandon ? 'Oui' : 'Non'}</p>
            </div>
            <div>
              <span className="font-medium text-gray-600">Diplômé :</span>
              <p className="font-semibold">{apprenant.estDiplome ? 'Oui' : 'Non'}</p>
            </div>
          </div>
        </div>

        {/* Insertion Professionnelle */}
        {apprenant.statutInsertion && apprenant.statutInsertion !== 'N/A' && (
          <div className="border-l-4 border-green-600 pl-4 bg-green-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-green-800 mb-3 flex items-center">
              <Icon name="briefcase" size={18} className="mr-2" />
              Insertion Professionnelle
            </h3>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="font-medium text-gray-600">Statut :</span>
                <p className="font-semibold">{apprenant.statutInsertion || '-'}</p>
              </div>
              <div>
                <span className="font-medium text-gray-600">Date première insertion :</span>
                <p className="font-semibold">{formatDate(apprenant.dateInsertion)}</p>
              </div>
              {(() => {
                const dernierChangement = apprenant.changementsEntreprise?.filter(c => c !== null)?.slice(-1)[0] || null;
                return (
                  <>
                    {dernierChangement && (
                      <div>
                        <span className="font-medium text-gray-600">Dernier changement d'entreprise :</span>
                        <p className="font-semibold">{formatDate(dernierChangement.dateChangement)}</p>
                      </div>
                    )}
                    <div>
                      <span className="font-medium text-gray-600">Type contrat :</span>
                      <p className="font-semibold">
                        {dernierChangement?.typeContrat || apprenant.typeContrat || '-'}
                      </p>
                    </div>
                    <div>
                      <span className="font-medium text-gray-600">Entreprise :</span>
                      <p className="font-semibold">
                        {dernierChangement?.entreprise || apprenant.entreprise || '-'}
                      </p>
                    </div>
                    <div>
                      <span className="font-medium text-gray-600">Poste :</span>
                      <p className="font-semibold">
                        {dernierChangement?.nouveauPoste || apprenant.poste || '-'}
                      </p>
                    </div>
                  </>
                );
              })()}
              <div>
                <span className="font-medium text-gray-600">Salaire :</span>
                <p className="font-semibold">
                  {apprenant.salaire ? `${apprenant.salaire.toLocaleString()} FCFA` : apprenant.salaireTranche || '-'}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Changements d'entreprise */}
        {apprenant.changementsEntreprise && apprenant.changementsEntreprise.filter(c => c !== null).length > 0 && (
          <div className="border-l-4 border-amber-600 pl-4 bg-amber-50 rounded-r-lg py-4 pr-4">
            <h3 className="font-bold text-amber-800 mb-3">🔄 Historique des Changements</h3>
            <div className="space-y-3">
              {apprenant.changementsEntreprise.filter(c => c !== null && c !== undefined).map((changement, idx) => (
                <div key={idx} className="bg-white rounded-lg p-3 border">
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div><span className="font-medium">Entreprise :</span> {changement.entreprise}</div>
                    <div><span className="font-medium">Date :</span> {formatDate(changement.dateChangement)}</div>
                    <div><span className="font-medium">Type contrat :</span> {changement.typeContrat}</div>
                    {changement.nouveauPoste && (
                      <div><span className="font-medium">Poste :</span> {changement.nouveauPoste}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Notes */}
        {apprenant.notes && (
          <div>
            <h3 className="font-bold mb-2 flex items-center">
              <Icon name="document" size={18} className="mr-2" />
              Notes
            </h3>
            <p className="text-sm bg-gray-50 rounded-lg p-3">{apprenant.notes}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalDetails;

